module.exports = __webpack_public_path__ + "img/04.460991a3.png";